module.exports = __webpack_public_path__ + "static/img/throttleProBg-2.1060326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/throttleProBg-2.png
// module id = WuiX
// module chunks = 1